import styled from "styled-components";

const Section = styled.section`
  margin-bottom: 5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export default Section;
